import React, { useRef } from "react";
import styled from "styled-components";
import styles from "./DialogModal.scss";
import { getRouter } from "../../utils/helper";
import Portal from "@tw/shared-ui-components/lib/components/portal/portal";
import { getQueryUTMString } from '@tw/shared-ui-components/lib/utils/helper';
const Background = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(44, 44, 44, 0.7);
  backdrop-filter: blur(10px);
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5;
  @media screen and (max-width: 425px) {
    top: 0;
    left: 0;
    z-index: 9999;
    position: fixed;
    background: rgba(44, 44, 44, 0.7);
  }
  @media screen and (min-width: 1200px) {
    // margin-left: -54px;
    // margin-top: -25px;
    // top: 25px;
    top: 0;
    left: 0;
    z-index: 9999;
    position: fixed;
  }
`;

const ModalWrapper = styled.div`
  width: 326px;
  height: 164px;
  box-shadow: 0 5px 16px rgba(0, 0, 0, 0.2);
  background: #fff;
  color: #000;
  position: relative;
  border-radius: 10px;

  z-index: 99999999999;
  @media screen and (min-width: 993px) {
    width: 460px;
    height: 280px;
    z-index: 99999999999;
    border-radius: 10px;
  }
`;

export const DialogModal = (props) => {
  const {
    showModal,
    setShowModal,
    listAction,
    isError,
    errorMessage,
    setModalState,
  } = props;
  const modalRef = useRef();

  const successMessage =
    listAction === "createList"
      ? "你已經成功新建清單"
      : "你已經成功添加商品到清單";

  const router = getRouter();
  const closeModal = (e) => {
    if (modalRef.current === e.target) {
      setShowModal(false);
    }
  };
  const handleSucess = () => {
    setShowModal((prev) => !prev);
    setModalState((prev) => !prev);
  };
  const checkMyList = () => {
    router.push(`/mylist${getQueryUTMString("?")}`)
  }
  if (!showModal) return null;

  return (
    <Portal>
      <Portal>
        <Background onClick={closeModal} ref={modalRef}>
          <ModalWrapper showModal={showModal}>
            <div className={styles["wrapper"]}>
              <svg
                className={styles["close"]}
                onClick={() => setShowModal((prev) => !prev)}
                width="10"
                height="11"
                viewBox="0 0 10 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.80469 5.75L9.53906 3.01562C9.89453 2.6875 9.89453 2.14062 9.53906 1.8125L8.9375 1.21094C8.60938 0.855469 8.0625 0.855469 7.73438 1.21094L5 3.94531L2.23828 1.21094C1.91016 0.855469 1.36328 0.855469 1.03516 1.21094L0.433594 1.8125C0.078125 2.14062 0.078125 2.6875 0.433594 3.01562L3.16797 5.75L0.433594 8.51172C0.078125 8.83984 0.078125 9.38672 0.433594 9.71484L1.03516 10.3164C1.36328 10.6719 1.91016 10.6719 2.23828 10.3164L5 7.58203L7.73438 10.3164C8.0625 10.6719 8.60938 10.6719 8.9375 10.3164L9.53906 9.71484C9.89453 9.38672 9.89453 8.83984 9.53906 8.51172L6.80469 5.75Z"
                  fill="#2C2C2C"
                />
              </svg>

              {isError ? (
                <>
                  <span className={styles["message-div"]}>{errorMessage}</span>
                  <div className={styles["error-outer-btn-div"]}>
                    <button
                      className={styles["mylist-btn"]}
                      onClick={() => setShowModal((prev) => !prev)}
                    >
                      確認
                    </button>
                  </div>
                </>
              ) : null}
              {listAction ? (
                <>
                  <span className={styles["message-div"]}>

                    {successMessage}

                  </span>

                  <div className={styles["outer-btn-div"]}>
                    <button
                      className={styles["more-product-btn"]}
                      onClick={handleSucess}
                    >
                      看更多商品
                    </button>

                    <button
                      className={styles["mylist-btn"]}
                      onClick={checkMyList}
                    >
                      查看我的清單
                    </button>
                  </div>
                </>
              ) : null}
            </div>
          </ModalWrapper>
        </Background>
      </Portal>
    </Portal>
  );
};

export default DialogModal;
